var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeDelivery24 = function SvgHomeDelivery24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.404 20.2v1.2c0 .159.065.311.18.424a.627.627 0 0 0 .438.176h1.363c.163 0 .32-.063.435-.175a.59.59 0 0 0 .18-.423v-5.106a.68.68 0 0 0-.19-.468 3.002 3.002 0 0 0-1.18-.726 1.897 1.897 0 0 0-.627-.102h-7.006a1.897 1.897 0 0 0-.626.102 3.002 3.002 0 0 0-1.18.726.68.68 0 0 0-.191.468v5.106c0 .159.065.31.18.423a.624.624 0 0 0 .436.175h1.362a.627.627 0 0 0 .437-.176.592.592 0 0 0 .181-.425V20.2h5.808Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5h2m7 0h2",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14s-.145-1.638-1.095-2.69a.921.921 0 0 0-.68-.31h-5.45a.907.907 0 0 0-.68.31C11.142 12.362 11 14 11 14m-.308-.5H9.308c-.17 0-.308.112-.308.25s.138.25.308.25h1.384c.17 0 .308-.112.308-.25s-.138-.25-.308-.25Zm11 0h-1.384c-.17 0-.308.112-.308.25s.138.25.308.25h1.384c.17 0 .308-.112.308-.25s-.138-.25-.308-.25ZM6 16H4v-6H2V7l9-5m0 0 4 3V3.016h3V6.5L20 8v1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHomeDelivery24;